// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__Y3Z3I","question":"Question_question__1H_03","description":"Question_description__3zsPb"};